module.exports = __webpack_public_path__ + "img/3.c432cb6f.png";